import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=0c2900bc"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2900bc')) {
      api.createRecord('0c2900bc', component.options)
    } else {
      api.reload('0c2900bc', component.options)
    }
    module.hot.accept("./FormStep.vue?vue&type=template&id=0c2900bc", function () {
      api.rerender('0c2900bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/good-design-award/components/FormStep.vue"
export default component.exports